import HomeHeader from "./components/HomeHeader";
import HomeFooter from "./components/HomeFooter";
import FormLoginUser from "./components/FormLogin";

import "./styles/form-login.css";

export default function Home() {
  return (
    <div className="home-layout">
      <HomeHeader />

      <FormLoginUser />

      <HomeFooter />
    </div>
  );
}
